import styled from 'styled-components';
import OrangeArrow from '../.././../assests/images/orange-right-arrow.svg';

export const TopBannerSection = styled.section`
    width: 100%;

    .link-to-us-banner{

        @media screen and (max-width: 1024px){
            padding-top: 160px;
        }
    }
`;

export const LinkToUsSection = styled.section`
    width: 100%;
    background: #F1FEFF;
    padding-bottom: 50px;
`;

export const LinkToUsWrap = styled.div`
    width: 100%;
    background: #FFFFFF;
    padding: 20px;
    border-radius: 15px;
    box-shadow: 0px 20px 20px #0000001A;
    margin-top: -124px;
    color: #333333;
    font-size: 18px;
    font-family: 'Jost', sans-serif;
    font-weight: 400;
    line-height: 28px;

    @media screen and (max-width: 767px){
        font-size: 16px;
        line-height: 26px;
        padding: 15px;
    }
`;

export const LinkToUsText = styled.p`
    margin: 0px;
    padding-bottom: 10px;
    &:last-child{
        padding-bottom: 0px;
    }
    a{
        text-decoration: none;
        color: #333;
    }
`;

export const LinkToUsTextStrong = styled.strong`
    font-weight: 
`;

export const SuggestionsListText = styled.div`
    color: #333333;
    font-size: 18px;
    font-family: 'Jost', sans-serif;
    font-weight: 400;
    line-height: 26px;
    margin-top: 5px;
    margin-bottom: 15px;
`;

export const SuggestionsUnorderedList = styled.ul`
    padding: 0px;
    list-style: none;
    margin-bottom: 0;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    row-gap: 12px;
`;

export const SuggestionsList = styled.li`
    color: #333333;
    font-size: 18px;
    font-family: 'Jost', sans-serif;
    font-weight: 400;
    line-height: 26px;
    padding-left: 30px;
    position: relative;

    @media screen and (max-width: 767px){
        font-size: 16px;
        line-height: 24px;
        padding-left: 25px;
    }

    &::before{
        content: '';
        position: absolute;
        background-image:url(${OrangeArrow});
        background-size: contain;
        background-position: left top;
        width: 20px;
        height: 18px;
        background-repeat: no-repeat;
        left: 0;
        top: 3px;

        @media screen and (max-width: 767px){
            width: 16px;
            height: 16px;
            top: 5px;
        }
    }
`;

export const LinkToUsMainTable = styled.section`

;`